module.exports = __webpack_public_path__ + "static/media/img-sobre.572e1396.jp2";